import { containsKey } from "features/shared/helpers/objects";
import { injectable } from "inversify";
import IDashboardService from "./IDashboardService";

@injectable()
export default class DashboardService implements IDashboardService {
  getConfiguration<T>(
    additionalInfo: object,
    configKey: string,
    configurationMap: Record<string, T>,
    componentName: string
  ): T {
    if (additionalInfo && containsKey(additionalInfo, configKey)) {
      let configuration = configurationMap[(additionalInfo as any)[configKey]];

      if (configuration) {
        return configuration;
      }

      throw Error(
        `Wrong configuration. Key '${configKey}' must contain one of this values: ${Object.keys(
          configurationMap
        ).join(", ")}`
      );
    }

    throw Error(
      `Wrong configuration. Component '${componentName}' must contain section 'additionalInfo' with key '${configKey}'.`
    );
  }

  getAdditionalInfoObj<T>(additionalInfo: object, infoKey: string): T | null {
    if (additionalInfo && containsKey(additionalInfo, infoKey)) {
      let result: T =  additionalInfo[infoKey as keyof typeof additionalInfo];

      if (result) {
        return result;
      }
    }

    return null
  }
}
